import React from 'react';

import Modal from './Modal';
import NewFirmContactForm from './NewFirmContactForm';

/*
Because we had already created the NewTaskForm, we just embedded this component within
our Modal structure.
Call this with
    <NewFirmContactModal
        show={the condition under which it should show}
        viewingFirmId={id}
        visibleFirmId={id}
        successFunc={(newConactId) => a function(newConactId) for reporting the new contact and closing the dialog}
        closeModalFunc={a function for closing the dialog}
    />
*/

class NewFirmContactModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: undefined,
    };
  }

  render() {
    if (this.state.errorMessage) {
      return <h3>{this.state.errorMessage}</h3>;
    }

    const { show } = this.props;
    return (
      <Modal open={show} title={'Add New Contact'} hideButtons={true} onCancel={this.props.closeModalFunc}>
        <NewFirmContactForm
          viewingFirmId={this.props.viewingFirmId}
          visibleFirmId={this.props.visibleFirmId}
          successFunc={this.props.successFunc}
          closeModalFunc={this.props.closeModalFunc}
        />
      </Modal>
    );
  }
}

export default NewFirmContactModal;
